import { useEffect } from "react";

export default function useDynamicTabName(tabName: string) {
  useEffect(() => {
    if (tabName) {
      document.title = tabName;
    }
  }, [tabName]);
}
